import { LayoutComponent } from './layout/layout/layout.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingsComponent } from './components/settings/settings.component';
import { CereriComponent } from './components/cereri/cereri.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BorderouComponent } from './components/borderou/borderou.component';
import { SectionsComponent } from './platform/nomenclatoare/sections/sections.component';
import { AdminSetariComponent } from './platform/nomenclatoare/administrativ/admin-setari/admin-setari.component';
import { TokenComponent } from './components/token/token.component';
import { TokenGuard } from './guards/token.guard';
import { PermissionsGuard } from './guards/permissions.guard';
import { CerereSabloaneComponent } from './platform/nomenclatoare/cerere-sabloane/cerere-sabloane.component';
import { ConfirmareDocumenteComponent } from './components/confirmare-documente/confirmare-documente.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/cereri',
        pathMatch: 'full',
    },

    {
        path: '',
        component: LayoutComponent,
        canActivate: [TokenGuard, PermissionsGuard],
        children: [
            {
                path: 'dashboard',
                component: DashboardComponent,
            },
            {
                path: 'settings',
                component: SettingsComponent,
            },
            {
                path: 'sabloane',
                component: CerereSabloaneComponent,
            },
            {
                path: 'confirmare-documente',
                component: ConfirmareDocumenteComponent,
            },
            {
                path: 'cereri',
                component: CereriComponent,
            },
            {
                path: 'borderou',
                component: BorderouComponent,
            },
            {
                path: 'sectiuni',
                component: SectionsComponent,
            },
            {
                path: 'admin-settings',
                component: AdminSetariComponent,
            },
        ],
    },
    {
        path: 'token/:token',
        component: TokenComponent,
    },
    {
        path: '**',
        redirectTo: '/cereri',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            useHash: true,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
